import { Copy, Send } from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatExpiry, ROLE_LABEL, type PendingInvite } from "./useWorkspaceMembers";

type Props = {
  invites: PendingInvite[];
  busyId: string | null;
  onCopy: (token: string) => void;
  onResend: (inv: PendingInvite) => void;
  onRevoke: (id: string) => void;
};

export const PendingInvitesList = ({ invites, busyId, onCopy, onResend, onRevoke }: Props) => {
  if (invites.length === 0) return null;
  return (
    <div className="space-y-2">
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">Pending invites</p>
      <ul className="divide-y divide-border rounded-md border border-border">
        {invites.map((inv) => (
          <li key={inv.id} className="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
            <div className="min-w-0">
              <p className="truncate text-sm font-medium">{inv.invited_email}</p>
              <p className="text-xs text-muted-foreground">
                {ROLE_LABEL[inv.role]} · {formatExpiry(inv.expires_at)}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <Button variant="outline" size="sm" onClick={() => onCopy(inv.token)}>
                <Copy className="h-4 w-4" /> Copy link
              </Button>
              <Button variant="outline" size="sm" onClick={() => onResend(inv)} disabled={busyId === inv.id}>
                <Send className="h-4 w-4" /> Resend
              </Button>
              <Button variant="outline" size="sm" onClick={() => onRevoke(inv.id)}>
                Revoke
              </Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
